'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wixRestaurantsJsSdk = require('wix-restaurants-js-sdk');

exports.default = _wixRestaurantsJsSdk.helpers.Image;